"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpRoutes = void 0;
const auth_route_1 = require("./auth_route");
class OtpRoutes extends auth_route_1.AuthRoute {
    constructor() {
        super('otp');
    }
    /** Trigger a phone OTP send (identical to "sendOtp") */
    sendPhoneOtp(phoneNumber) {
        return this.post(`/phone`, { phoneNumber });
    }
    /** Trigger an email OTP send */
    sendEmailOtp(emailAddress) {
        return this.post(`/email`, { emailAddress });
    }
    /** Get the current USSD authentication status
     * The endpoint will return a response with syntax:
     * { canVerifyViaUSSD: boolean, ussdVerificationBaseCode: string }
     * @param { string } phoneNumber Phone number that is being logged in with
     */
    getUssdStatus(phoneNumber) {
        return this.get(`/ussdStatus?phoneNumber=${phoneNumber}`);
    }
}
exports.OtpRoutes = OtpRoutes;
//# sourceMappingURL=otp.js.map